import Icon from "@/v2-ui/icon"
import Tooltip from "@/v2-ui/tooltip"

export type LicenseFeatureGroupIncludedMarkProps = {
  /** The reason, in full: "Included via Placepoint Enterprise. Ends if…". */
  title: string
}

// The fixed tick a row shows through the customer lens when the product or
// a license already includes it: the same footprint as the checkbox it
// stands in for, so the list reads as one column of answers — a tick is
// "they have it", an empty box is "they don't, tick to add it" — and the
// reason sits one hover away. Not a control: nothing on this tab can take
// a free or licensed item away, and the mark says so by not being a box.
function LicenseFeatureGroupIncludedMark(
  props: LicenseFeatureGroupIncludedMarkProps,
) {
  const { title } = props
  return (
    <Tooltip>
      <Tooltip.Trigger asChild>
        <span
          role="img"
          aria-label={title}
          className="flex size-4 shrink-0 cursor-help items-center justify-center text-primary"
        >
          <Icon src="check" size={14} />
        </span>
      </Tooltip.Trigger>
      <Tooltip.Content side="top" className="max-w-[300px]">
        {title}
      </Tooltip.Content>
    </Tooltip>
  )
}

export default LicenseFeatureGroupIncludedMark
